import React, { ChangeEventHandler, useState } from "react";
import { MediumHeader } from "@narvar/nth-bit-header";
import Button from "@narvar/nth-block-button";
import TextArea from "@narvar/nth-block-text-area";
import { useTranslations } from "@narvar/nth-hook-translations";
import LanguageKeys from "../../ReviewSummary/consts/language_en_US";
import { useStyles } from "./ReturnReasonsCommentsStyles";
import { useLanguage } from "@narvar/nth-kit-returns-headless";
import Checkbox from "@narvar/nth-block-checkbox";
import { Language } from "../../ReviewSummary/components";
import { ReturnReasonsCommentsProps } from "./types";

const tempLanguageKeys = {
  returnsReasonsCommentsPlaceholderRequired:
    LanguageKeys.returnsReasonsCommentsPlaceholderRequired,
};

const ReturnReasonsComments = ({
  onChange,
  customerComments,
  required,
  attestation,
  attested,
  hideSubmit,
  onSubmit,
}: ReturnReasonsCommentsProps) => {
  const styles = useStyles();
  const {
    returnsReasonsCommentsTitle,
    returnsReasonsCommentsPlaceholder,
    returnsActionsNext,
  } = useTranslations();
  const { returnsReasonsCommentsPlaceholderRequired } = tempLanguageKeys;
  const [elId] = useState(`customer-comment-${Math.random()}`);

  const handleCommentChange: ChangeEventHandler<HTMLTextAreaElement> = (
    event,
  ) => {
    onChange({
      customerComments: event.target.value,
      attested,
    });
  };
  const handleAttestedChange: ChangeEventHandler<HTMLInputElement> = (
    event,
  ) => {
    onChange({
      customerComments: customerComments,
      attested: event.target.checked,
    });
  };
  const handleSubmit = () => {
    onSubmit();
  };

  const { rawValue: returnsReasonsCommentsPlaceholderRaw } = useLanguage({
    langKey: "returnsReasonsCommentsPlaceholder",
  });
  const requiredPlaceholder = useLanguage({
    langKey: "returnsReasonsCommentsPlaceholderRequired",
    defaultString: returnsReasonsCommentsPlaceholderRequired,
  }).rawValue;

  const textAreaLabel = required
    ? requiredPlaceholder
    : (returnsReasonsCommentsPlaceholder ??
      returnsReasonsCommentsPlaceholderRaw);

  const isValid =
    (!required || customerComments.length > 0) && (!attestation || attested);

  return (
    <>
      <MediumHeader>
        <Language
          langKey="returnsReasonsCommentsTitle"
          defaultString={returnsReasonsCommentsTitle}
        />
      </MediumHeader>
      <div className={styles.commentWrapper}>
        {attestation && (
          <Checkbox
            checked={attested}
            id="attestationCheckbox"
            onChange={handleAttestedChange}>
            {attestation}
          </Checkbox>
        )}
        <TextArea
          className={styles.textarea}
          id={elId}
          onChange={handleCommentChange}
          value={customerComments}
          placeholder={textAreaLabel}
        />
      </div>
      {!hideSubmit && (
        <Button big disabled={!isValid} onClick={handleSubmit}>
          <Language
            langKey="returnsActionsNext"
            defaultString={returnsActionsNext}
          />
        </Button>
      )}
    </>
  );
};

export default ReturnReasonsComments;
